import _objectSpread from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _typeof from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import Head from "@/components/Head/index.vue";
import * as echarts from "echarts"; // import dayjs from "dayjs";
// import { useRouter } from "vue-router";

import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, onMounted, reactive, ref, watch } from "vue";
import { useStore } from "vuex"; // import { CountTo } from 'vue3-count-to';

export default defineComponent({
  name: "DataAnalysisIndex",
  components: {
    Head: Head
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties; // const router = useRouter();


    var store = useStore(); // 配置显示隐藏情况

    var meunList = ref(store.state.column.meunList); //相关模块id

    function getFlag(keyword) {
      return meunList.value.find(function (item) {
        return item.keyword == keyword;
      }).flag;
    } // 模块参考地图，module只用说明keyword所对应的模块，代码中未使用


    var displayModulearr = ref([{
      keyword: 'meeting',
      module: '会议',
      flag: getFlag('meeting')
    }, {
      keyword: 'annualCheck',
      module: '考核',
      flag: getFlag('annualCheck')
    }, {
      keyword: 'payMoney',
      module: '党费',
      flag: getFlag('payMoney')
    }]); // // 确定eCharts图是否显示
    // const eChartsShow =  computed(() => {
    //   return (keyword)=>{
    //     let obj =JSON.parse(JSON.stringify(displayModulearr.value.find(item=>{
    //       return item.keyword==keyword
    //     }))) 
    //     return  obj.flag
    //   }
    // });
    // 判断模块是否显示

    var setDisplayModulearr = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Data.options.forEach(function (item) {
                  var e = meunList.value.find(function (meu) {
                    return meu.keyword == item.keyword;
                  });

                  if (e) {
                    if (e.adminType) {
                      item.flag = e.adminType == 1 ? true : false;
                    } else {
                      item.flag = e.flag;
                    }
                  }
                }); // displayModulearr.value.forEach(item=>{
                //   let e = meunList.value.find(meu=>{
                //     return meu.keyword==item.keyword
                //   })
                //   if(e.adminType){
                //     item.flag=e.adminType==1 ?  true : false
                //   }else{
                //     item.flag=e.flag
                //   }
                // })

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function setDisplayModulearr() {
        return _ref.apply(this, arguments);
      };
    }();

    var Data = reactive({
      month: new Date(),
      myData: {
        exam: 0,
        meeting: 0,
        money: 0
      },
      treeData: [],
      defaultProps: {
        children: "children",
        label: "orgName"
      },
      value: {
        organizeId: -1,
        orgName: ""
      },
      options: [// 党费统计 2 0
      {
        id: "eCharts2",
        type: 1,
        label: "党费统计",
        keyword: 'payMoney',
        flag: true,
        eCharts: {
          title: {
            text: "党费统计"
          },
          legend: {
            orient: "vertical",
            right: "150px",
            bottom: "20px"
          },
          grid: {
            top: "60rpx",
            left: "50rpx",
            right: "20rpx",
            bottom: "20rpx"
          },
          series: [{
            name: "党费统计",
            type: "pie",
            radius: ["40%", "70%"],
            data: [{
              value: 0,
              name: "实缴党费",
              itemStyle: {
                color: "#ff9c00"
              }
            }, {
              value: 0,
              name: "拖欠党费",
              itemStyle: {
                color: "#ea2525"
              }
            }],
            left: "-250px"
          }],
          tooltip: {
            trigger: "item"
          }
        }
      }, // 党员情况分析 3 1
      {
        id: "eCharts-3",
        type: 1,
        label: "党员情况分析",
        title: "党员总数：",
        content: "党员情况分析",
        num: "0",
        unit: "人",
        keyword: 'baseUserIndex',
        flag: true,
        eCharts: {
          title: {
            text: "党员情况分析"
          },
          xAxis: {
            type: "category",
            data: [],
            boundaryGap: false,
            axisTick: {
              show: false
            },
            axisLabel: {
              align: "center",
              fontSize: 10,
              interval: 0
            }
          },
          grid: {
            top: "60rpx",
            left: "50rpx",
            right: "20rpx",
            bottom: "20rpx"
          },
          yAxis: {
            type: "value",
            splitNumber: 5
          },
          series: [{
            data: [],
            clip: true,
            type: "line",
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: "#fe9516"
                }, {
                  offset: 1,
                  color: "#ffcb8c"
                }],
                global: false
              }
            },
            symbol: "circle",
            symbolSize: 0,
            lineStyle: {
              color: "#f68874"
            }
          }],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross"
            }
          }
        }
      }, // 党员性别分析 4 2
      {
        id: "eCharts-4",
        type: 1,
        label: "党员性别分析",
        title: "党员总数：",
        content: "党员性别分析",
        num: "0",
        unit: "人",
        keyword: 'baseUserIndex',
        flag: true,
        eCharts: {
          title: {
            text: "党员性别分析"
          },
          legend: {
            orient: "vertical",
            right: "150px",
            bottom: "20px"
          },
          grid: {
            top: "60rpx",
            left: "50rpx",
            right: "20rpx",
            bottom: "20rpx"
          },
          series: [{
            name: "党员性别分析",
            type: "pie",
            radius: ["40%", "70%"],
            data: [{
              value: 0,
              name: "女性",
              itemStyle: {
                color: "#ff9c00"
              }
            }, {
              value: 0,
              name: "男性",
              itemStyle: {
                color: "#ea2525"
              }
            }],
            left: "-160rpx"
          }],
          tooltip: {
            trigger: "item"
          }
        }
      }, // 党员民族占比分析 5 3
      {
        id: "eCharts-5",
        type: 1,
        label: "党员民族占比分析",
        title: "党员总数：",
        content: "党员民族占比分析",
        num: "0",
        unit: "人",
        keyword: 'baseUserIndex',
        flag: true,
        eCharts: {
          title: {
            text: "党员民族占比分析"
          },
          legend: {
            orient: "vertical",
            right: "150px",
            bottom: "20px"
          },
          grid: {
            top: "60rpx",
            left: "50rpx",
            right: "20rpx",
            bottom: "20rpx"
          },
          series: [{
            name: "少数民族占比分析",
            type: "pie",
            radius: ["40%", "70%"],
            data: [{
              value: 0,
              name: "少数民族",
              itemStyle: {
                color: "#ff9c00"
              }
            }, {
              value: 0,
              name: "非少数民族",
              itemStyle: {
                color: "#ea2525"
              }
            }],
            left: "-160rpx"
          }],
          tooltip: {
            trigger: "item"
          }
        }
      }, // 会议开展统计 6 4
      {
        id: "eCharts-6",
        type: 1,
        label: "会议开展统计",
        keyword: 'meeting',
        flag: true,
        eCharts: {
          title: {
            text: "会议开展统计"
          },
          xAxis: {
            type: "category",
            data: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]
          },
          yAxis: {
            type: "value",
            splitNumber: 5
          },
          grid: {
            top: "60rpx",
            left: "50rpx",
            right: "20rpx",
            bottom: "20rpx"
          },
          series: [{
            data: [],
            type: "line",
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: "#fe9516"
                }, {
                  offset: 1,
                  color: "#ffcb8c"
                }],
                global: false
              }
            },
            symbol: "circle",
            symbolSize: 0,
            lineStyle: {
              color: "#ffbd6e"
            }
          }],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross"
            }
          }
        }
      }, // 党日活动开展情况分析 7 5
      {
        id: "eCharts-7",
        type: 1,
        label: "党日活动开展情况分析",
        keyword: 'activity',
        flag: true,
        eCharts: {
          title: {
            text: "党日活动开展情况分析"
          },
          xAxis: {
            type: "category",
            data: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]
          },
          yAxis: {
            type: "value"
          },
          grid: {
            top: "60rpx",
            left: "50rpx",
            right: "20rpx",
            bottom: "20rpx"
          },
          series: [{
            data: [],
            type: "line",
            areaStyle: {},
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#4b95d2"
              }, {
                offset: 1,
                color: "#d5e8f6"
              }])
            },
            smooth: true,
            symbolSize: 0,
            lineStyle: {
              color: "#4b95d2"
            }
          }],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross"
            }
          }
        }
      }, // 调查问卷开展情况分析 8 6
      {
        id: "eCharts-8",
        type: 1,
        label: "调查问卷开展情况分析",
        keyword: 'questionnaire',
        flag: true,
        eCharts: {
          title: {
            text: "调查问卷开展情况分析"
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]
          },
          yAxis: {
            type: "value"
          },
          grid: {
            top: "60rpx",
            left: "50rpx",
            right: "20rpx",
            bottom: "20rpx"
          },
          series: [{
            data: [],
            type: "line",
            lineStyle: {
              color: "#f4f4f4"
            }
          }],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross"
            }
          }
        }
      }, // 思想摸排开展情况分析 9 7
      {
        id: "eCharts-9",
        type: 1,
        label: "思想摸排开展情况分析",
        keyword: 'thought',
        flag: true,
        eCharts: {
          title: {
            text: "思想摸排开展情况分析"
          },
          xAxis: {
            type: "category",
            data: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]
          },
          yAxis: {
            type: "value"
          },
          grid: {
            top: "60rpx",
            left: "50rpx",
            right: "20rpx",
            bottom: "20rpx"
          },
          label: {
            show: true,
            position: "top",
            textStyle: {
              //数值样式
              color: "black",
              fontSize: 16
            }
          },
          series: [{
            data: [],
            type: "bar",
            itemStyle: {
              borderRadius: [2, 2, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#d3c6f2"
              }, {
                offset: 1,
                color: "#9b87d4"
              }])
            }
          }],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross"
            }
          }
        }
      }, // 网上考试开展情况分析 10 8
      {
        id: "eCharts-10",
        type: 1,
        label: "网上考试开展情况分析",
        keyword: 'exam',
        flag: true,
        eCharts: {
          title: {
            text: "网上考试开展情况分析"
          },
          xAxis: {
            type: "category",
            data: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]
          },
          yAxis: {
            type: "value"
          },
          grid: {
            top: "60rpx",
            left: "50rpx",
            right: "20rpx",
            bottom: "20rpx"
          },
          series: [{
            data: [],
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 0,
            lineStyle: {
              color: "#ffbd6e"
            }
          }, {
            data: [],
            type: "bar",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "white"
              }, {
                offset: 1,
                color: "#fce8ed"
              }])
            },
            emphasis: {
              itemStyle: {
                color: "#f02525"
              }
            }
          }],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross"
            }
          }
        }
      }, // 大专及以上学历党员 11 9
      {
        id: "eCharts-11",
        type: 1,
        label: "大专及以上学历党员",
        title: "党员总数：",
        content: "大专及以上学历党员",
        num: "0",
        unit: "人",
        keyword: 'baseUserIndex',
        flag: true,
        eCharts: {
          title: {
            text: "大专及以上学历党员"
          },
          legend: {
            orient: "vertical",
            right: "150px",
            bottom: "20px"
          },
          grid: {
            top: "60rpx",
            left: "50rpx",
            right: "20rpx",
            bottom: "20rpx"
          },
          average: "0",
          itemStyle: [{
            itemStyle: {
              color: "#ff3241"
            }
          }, {
            itemStyle: {
              color: "#f6d1a8"
            }
          }],
          series: [{
            name: "党员民族占比分析",
            type: "pie",
            radius: ["40%", "70%"],
            data: [{
              value: 0,
              name: "大专以上",
              itemStyle: {
                color: "#ff9c00"
              }
            }, {
              value: 0,
              name: "大专以下",
              itemStyle: {
                color: "#ea2525"
              }
            }],
            left: "-160rpx"
          }],
          tooltip: {
            trigger: "item"
          }
        }
      }],
      isDom: false
    });
    onMounted(function () {
      getList();
    });

    var getList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getOrgTree();

              case 2:
                _context2.next = 4;
                return getMyData();

              case 4:
                _context2.next = 6;
                return getAlleCharts();

              case 6:
                _context2.next = 8;
                return getMountEcherts();

              case 8:
                Data.isDom = true;

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getList() {
        return _ref2.apply(this, arguments);
      };
    }();

    var SelectRef = ref(null);

    var handleNodeClick = function handleNodeClick(item) {
      if (SelectRef.value) {
        SelectRef.value.blur();
      }

      Data.value.organizeId = item.organizeId;
      Data.value.orgName = item.orgName;
    };

    watch(function () {
      return Data.value.orgName;
    }, function () {
      getList();
    }); // 全部eCharts

    var getAlleCharts = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var i, item;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                setDisplayModulearr(); // 党费缴纳
                // await getDataAnalysisParty();
                //   // 党员情况分析
                // await getDataAnalysisYear();
                // // 党员性别分析
                // await getDataAnalysisGender();
                // // 党员民族占比情况分析
                // await getDataAnalysisNation();
                // // 查看会议本年的列表
                // await getDataAnalysisMeeting();
                //  // 查看活动本年的列表
                // await getDataAnalysisActivity();
                //   // 查看调查问卷本年的列表
                // await getDataAnalysisQuestion();  
                // // 思想摸排
                // await getDataAnalysisTalk();
                // // 网上考试
                // await getDataAnalysisExam();       
                //  // 大专及以上学历党员
                // await getDataAnalysisEducation();

                _context3.t0 = regeneratorRuntime.keys(Data.options);

              case 2:
                if ((_context3.t1 = _context3.t0()).done) {
                  _context3.next = 42;
                  break;
                }

                i = _context3.t1.value;
                item = Data.options[i];

                if (!item.flag) {
                  _context3.next = 40;
                  break;
                }

                _context3.t2 = item.id;
                _context3.next = _context3.t2 === 'eCharts2' ? 9 : _context3.t2 === 'eCharts-3' ? 12 : _context3.t2 === 'eCharts-4' ? 15 : _context3.t2 === 'eCharts-5' ? 18 : _context3.t2 === 'eCharts-6' ? 21 : _context3.t2 === 'eCharts-7' ? 24 : _context3.t2 === 'eCharts-8' ? 27 : _context3.t2 === 'eCharts-9' ? 30 : _context3.t2 === 'eCharts-10' ? 33 : _context3.t2 === 'eCharts-11' ? 36 : 39;
                break;

              case 9:
                _context3.next = 11;
                return getDataAnalysisParty();

              case 11:
                return _context3.abrupt("break", 40);

              case 12:
                _context3.next = 14;
                return getDataAnalysisYear();

              case 14:
                return _context3.abrupt("break", 40);

              case 15:
                _context3.next = 17;
                return getDataAnalysisGender();

              case 17:
                return _context3.abrupt("break", 40);

              case 18:
                _context3.next = 20;
                return getDataAnalysisNation();

              case 20:
                return _context3.abrupt("break", 40);

              case 21:
                _context3.next = 23;
                return getDataAnalysisMeeting();

              case 23:
                return _context3.abrupt("break", 40);

              case 24:
                _context3.next = 26;
                return getDataAnalysisActivity();

              case 26:
                return _context3.abrupt("break", 40);

              case 27:
                _context3.next = 29;
                return getDataAnalysisQuestion();

              case 29:
                return _context3.abrupt("break", 40);

              case 30:
                _context3.next = 32;
                return getDataAnalysisTalk();

              case 32:
                return _context3.abrupt("break", 40);

              case 33:
                _context3.next = 35;
                return getDataAnalysisExam();

              case 35:
                return _context3.abrupt("break", 40);

              case 36:
                _context3.next = 38;
                return getDataAnalysisEducation();

              case 38:
                return _context3.abrupt("break", 40);

              case 39:
                return _context3.abrupt("break", 40);

              case 40:
                _context3.next = 2;
                break;

              case 42:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function getAlleCharts() {
        return _ref3.apply(this, arguments);
      };
    }(); // 党费缴纳


    var getDataAnalysisParty = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getDataAnalysisParty"]({
                  organizeId: Data.value.organizeId == -1 ? "" : Data.value.organizeId
                });

              case 2:
                res = _context4.sent;

                if (res.code == 0) {
                  if (_typeof(Data.options[0].eCharts.series[0].data[0]) == "object" && _typeof(Data.options[0].eCharts.series[0].data[1]) == "object") {
                    Data.options[0].eCharts.series[0].data[0].value = res.data.pay;
                    Data.options[0].eCharts.series[0].data[1].value = res.data.notPay;
                  }
                }

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function getDataAnalysisParty() {
        return _ref4.apply(this, arguments);
      };
    }(); // 党员情况分析


    var getDataAnalysisYear = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var eChartsX, eChartsY, res, _Data$options$1$eChar, _iterator, _step, v;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                eChartsX = [];
                eChartsY = [];
                _context5.next = 4;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getDataAnalysisYear"]({
                  organizeId: Data.value.organizeId == -1 ? "" : Data.value.organizeId
                });

              case 4:
                res = _context5.sent;

                if (res.code == 0) {
                  _iterator = _createForOfIteratorHelper(res.data);

                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      v = _step.value;
                      eChartsX.push(v.year);
                      eChartsY.push({
                        value: v.number
                      });
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }

                  if ((_Data$options$1$eChar = Data.options[1].eCharts.xAxis) !== null && _Data$options$1$eChar !== void 0 && _Data$options$1$eChar.data) Data.options[1].eCharts.xAxis.data = eChartsX;
                  if (Data.options[1].eCharts.series[0].data) Data.options[1].eCharts.series[0].data = eChartsY;
                }

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function getDataAnalysisYear() {
        return _ref5.apply(this, arguments);
      };
    }(); // 党员性别分析


    var getDataAnalysisGender = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getDataAnalysisGender"]({
                  organizeId: Data.value.organizeId == -1 ? "" : Data.value.organizeId
                });

              case 2:
                res = _context6.sent;

                if (res.code == 0) {
                  if (_typeof(Data.options[2].eCharts.series[0].data[0]) == "object" && _typeof(Data.options[2].eCharts.series[0].data[1]) == "object") {
                    Data.options[2].eCharts.series[0].data[0].value = res.data.num;
                    Data.options[2].eCharts.series[0].data[1].value = res.data.total - res.data.num;
                  }
                }

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function getDataAnalysisGender() {
        return _ref6.apply(this, arguments);
      };
    }(); // 党员民族占比情况分析


    var getDataAnalysisNation = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getDataAnalysisNation"]({
                  organizeId: Data.value.organizeId == -1 ? "" : Data.value.organizeId
                });

              case 2:
                res = _context7.sent;
                console.log('res: ', res);

                if (res.code == 0) {
                  if (_typeof(Data.options[3].eCharts.series[0].data[0]) == "object" && _typeof(Data.options[3].eCharts.series[0].data[1]) == "object") {
                    Data.options[3].eCharts.series[0].data[0].value = res.data.num;
                    Data.options[3].eCharts.series[0].data[1].value = res.data.total - res.data.num;
                  }
                }

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function getDataAnalysisNation() {
        return _ref7.apply(this, arguments);
      };
    }(); // 查看会议本年的列表


    var getDataAnalysisMeeting = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var res;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getDataAnalysisMeeting"]({
                  organizeId: Data.value.organizeId == -1 ? "" : Data.value.organizeId
                });

              case 2:
                res = _context8.sent;

                if (res.code == 0) {
                  if (Data.options[4].eCharts.series[0].data) Data.options[4].eCharts.series[0].data = res.data.mouthly;
                }

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      return function getDataAnalysisMeeting() {
        return _ref8.apply(this, arguments);
      };
    }(); // 查看活动本年的列表


    var getDataAnalysisActivity = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var res;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getDataAnalysisActivity"]({
                  organizeId: Data.value.organizeId == -1 ? "" : Data.value.organizeId
                });

              case 2:
                res = _context9.sent;

                if (res.code == 0) {
                  if (Data.options[5].eCharts.series[0].data) Data.options[5].eCharts.series[0].data = res.data.mouthly;
                }

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      return function getDataAnalysisActivity() {
        return _ref9.apply(this, arguments);
      };
    }(); // 查看调查问卷本年的列表


    var getDataAnalysisQuestion = /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var res;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getDataAnalysisQuestion"]({
                  organizeId: Data.value.organizeId == -1 ? "" : Data.value.organizeId
                });

              case 2:
                res = _context10.sent;

                if (res.code == 0) {
                  if (Data.options[6].eCharts.series[0].data) Data.options[6].eCharts.series[0].data = res.data.mouthly;
                }

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      return function getDataAnalysisQuestion() {
        return _ref10.apply(this, arguments);
      };
    }(); // 思想摸排


    var getDataAnalysisTalk = /*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var res;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getDataAnalysisTalk"]({
                  organizeId: Data.value.organizeId == -1 ? "" : Data.value.organizeId
                });

              case 2:
                res = _context11.sent;

                if (res.code == 0) {
                  if (Data.options[7].eCharts.series[0].data) Data.options[7].eCharts.series[0].data = res.data.mouthly;
                }

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      return function getDataAnalysisTalk() {
        return _ref11.apply(this, arguments);
      };
    }(); // 网上考试


    var getDataAnalysisExam = /*#__PURE__*/function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var res;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getDataAnalysisExam"]({
                  organizeId: Data.value.organizeId == -1 ? "" : Data.value.organizeId
                });

              case 2:
                res = _context12.sent;

                if (res.code == 0) {
                  if (Data.options[8].eCharts.series[0].data) Data.options[8].eCharts.series[0].data = res.data.mouthly;
                  Data.options[8].eCharts.series[1].data = res.data.mouthly;
                }

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      return function getDataAnalysisExam() {
        return _ref12.apply(this, arguments);
      };
    }(); // 大专及以上学历党员


    var getDataAnalysisEducation = /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var res;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getDataAnalysisEducation"]({
                  organizeId: Data.value.organizeId == -1 ? "" : Data.value.organizeId
                });

              case 2:
                res = _context13.sent;
                console.log('res: ', res);

                if (res.code == 0) {
                  if (_typeof(Data.options[9].eCharts.series[0].data[0]) == "object" && _typeof(Data.options[9].eCharts.series[0].data[1]) == "object") {
                    Data.options[9].eCharts.series[0].data[0].value = res.data.num;
                    Data.options[9].eCharts.series[0].data[1].value = res.data.total - res.data.num;
                  }
                }

              case 5:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      return function getDataAnalysisEducation() {
        return _ref13.apply(this, arguments);
      };
    }();

    watch(function () {
      return Data.month;
    }, function () {
      getMyData();
    }); // 我的会议-考核-党费数据

    var getMyData = /*#__PURE__*/function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var newMonth, searchTime, res;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                newMonth = "";
                newMonth = String(Data.month.getMonth()).length == 1 ? "0" + String(Data.month.getMonth() + 1) : String(Data.month.getMonth() + 1);
                searchTime = "".concat(Data.month.getFullYear(), "-").concat(newMonth);
                _context14.next = 5;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["dataAnalysisMyData"]({
                  searchTime: searchTime
                });

              case 5:
                res = _context14.sent;
                Data.myData.exam = res.data.exam || 0;
                Data.myData.meeting = res.data.meeting || 0;
                Data.myData.money = res.data.money || 0;

              case 9:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      return function getMyData() {
        return _ref14.apply(this, arguments);
      };
    }(); // 获取组织树


    var getOrgTree = /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var res;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["dataAnalysisTree"]({});

              case 2:
                res = _context15.sent;
                Data.treeData = res.data[0].children;

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      return function getOrgTree() {
        return _ref15.apply(this, arguments);
      };
    }(); //挂载eCharts


    var myChart = ref([]);

    var getMountEcherts = function getMountEcherts() {
      // let arr=Data.options.filter(item=>{
      //   return item.flag
      // })
      if (myChart.value.length == 0) {
        var _iterator2 = _createForOfIteratorHelper(Data.options),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var v = _step2.value;
            var eChart = document.getElementById(v.id);

            if (eChart) {
              myChart.value.push(echarts.init(eChart));
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      for (var index in myChart.value) {
        var option = _objectSpread({}, Data.options[index].eCharts);

        myChart.value[index].setOption(option);
      }
    };

    return {
      displayModulearr: displayModulearr,
      Data: Data,
      handleNodeClick: handleNodeClick,
      SelectRef: SelectRef,
      getOrgTree: getOrgTree,
      getMountEcherts: getMountEcherts,
      getList: getList,
      getAlleCharts: getAlleCharts,
      myChart: myChart,
      getDataAnalysisYear: getDataAnalysisYear,
      getDataAnalysisGender: getDataAnalysisGender,
      getDataAnalysisNation: getDataAnalysisNation,
      getDataAnalysisEducation: getDataAnalysisEducation,
      getDataAnalysisMeeting: getDataAnalysisMeeting,
      getDataAnalysisActivity: getDataAnalysisActivity,
      getDataAnalysisQuestion: getDataAnalysisQuestion,
      getDataAnalysisTalk: getDataAnalysisTalk,
      getDataAnalysisExam: getDataAnalysisExam,
      getDataAnalysisParty: getDataAnalysisParty
    };
  }
});